import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  readAllByEmisor: (emisor, cursor, limit = 10) =>
    api
      .send({
        query: gql`
          query READ_ALL_ROLES($emisor: ID!, $cursor: String, $limit: Int) {
            Role {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit) {
                feed {
                  _id
                  name
                  events {
                    _id
                    name

                    group {
                      _id
                      name
                      path
                      check
                    }
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit
        }
      })
      .then(result => result.data.data.Role.readAllByEmisor),

  readAllEvents: () =>
    api
      .send({
        query: gql`
          query READ_ALL_EVENTS {
            Event {
              readAll {
                _id
                name
                group {
                  _id
                  name
                  path
                }
              }
            }
          }
        `
      })
      .then(result => result.data.data.Event.readAll),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE_ROLE($input: RoleInput!) {
            Role {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Role.create),

  readById: _id =>
    api
      .send({
        query: gql`
          query READ_BY_ID($_id: ID!) {
            Role {
              readById(_id: $_id) {
                _id
                name
                events {
                  _id
                  name
                  group {
                    _id
                    name
                    path
                    check
                  }
                }

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Role.readById),

  delete: input =>
    api
      .send({
        query: gql`
          mutation delete($input: [ID!]!) {
            Role {
              delete(input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input }
      })
      .then(result => result.data.data.Role.delete)
}
